import { ActionIcon, Avatar, Flex, Text, Tooltip } from "@mantine/core";
import { openConfirmModal } from "@mantine/modals";
import { IconCircleCheck, IconCircleMinus, IconEye, IconPhoto } from "@tabler/icons-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoleApi } from "../../apis";
import { dateTimeFormat } from "../../utils/date";
import { Message } from "../../utils/message";
import { renderName } from "../../utils/render-name";
import { PopoverText } from "../popover-text/popover-text";
import { ColumnType, Table } from "../table";
import { Tag } from "../tags";
import RenderText from "../ui/render-text";

const RoleList = () => {
  const navigate = useNavigate();
  const [dataUpdated, setDataUpdated] = useState(false);

  const columns = useHeader({
    onClick: (key, item) => {
      switch (key) {
        case "detail": {
          navigate(`/users/role/${item?.id}`);
          break;
        }
        case "active": {
          openConfirmModal({
            title: `${item.roleStatus === "ACTIVE" ? "Роль идэвхгүй болгох" : "Роль идэвхжүүлэх"}`,
            children: <Text>Хэрэглэгчийн ролийг {item.roleStatus === "ACTIVE" ? "идэвхгүй" : "идэвхтэй"} болгох уу ?</Text>,
            labels: { confirm: `${item.roleStatus === "ACTIVE" ? "Идэвхгүй болгох" : "Идэвхжүүлэх"}`, cancel: "Болих" },
            onConfirm: async () => {
              try {
                const res = await RoleApi.active(item.id, item.roleStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE");
                if (res) {
                  Message.success("Үйлдэл амжилттай");
                  setDataUpdated((prev) => !prev);
                }
              } catch (error: any) {
                Message.error(error?.message);
              }
            },
            centered: true,
          });
          break;
        }
      }
    },
  });

  return <Table name="user-roles.list" columns={columns} loadData={(data) => RoleApi.list(data!)} key={dataUpdated ? "data-updated" : "data"} />;
};

export default RoleList;

const useHeader = ({ onClick }: { onClick: (key: string, record: any) => void }): ColumnType<any>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Үйлдэл",
    render: (record) => {
      return (
        <Flex gap="sm">
          <Tooltip label="Дэлгэрэнгүй" position="top">
            <ActionIcon variant="light" onClick={() => onClick("detail", record ?? "-")}>
              <IconEye />
            </ActionIcon>
          </Tooltip>
          <Tooltip label={record?.roleStatus === "ACTIVE" ? "Идэвхгүй болгох" : "Идэвхтэй болгох"} position="top">
            <ActionIcon variant="light" onClick={() => onClick("active", record ?? "-")}>
              {record?.roleStatus === "ACTIVE" ? <IconCircleMinus /> : <IconCircleCheck />}
            </ActionIcon>
          </Tooltip>
        </Flex>
      );
    },
  },
  {
    title: "Нэр",
    dataIndex: "nameMN",
    render: (record) => <RenderText text={record?.nameMN ?? "-"} />,
  },
  {
    title: "Эрхийн төлөв",
    dataIndex: "roleStatus",
    render: (record) => <Tag name={record?.roleStatus === "ACTIVE" ? "Идэвхтэй" : "Идэвхгүй"} color={record?.roleStatus === "ACTIVE" ? "green.5" : "red.5"} />,
  },
  {
    title: "Тайлбар",
    dataIndex: "description",
    render: (record) => <PopoverText>{record?.description ?? "-"}</PopoverText>,
  },
  {
    title: "Бүртгэсэн",
    dataIndex: "regUser",
    render: (record) => (
      <Flex align="center" gap="sm">
        <Avatar src={record?.regUser?.avatar ?? "-"}>
          <IconPhoto />
        </Avatar>
        <RenderText text={renderName(record?.regUser)} />
      </Flex>
    ),
  },
  {
    title: "Хэрэглэгчийн тоо",
    dataIndex: "userCount",
    render: (record) => <RenderText text={record?.userCount ?? 0} />,
  },
  {
    title: "Үүссэн огноо",
    dataIndex: "createdAt",
    render: (record) => <RenderText text={dateTimeFormat(record?.createdAt ?? "-")} />,
  },
];
